import { RequestCancel } from '@goodt-wcore/errors';

/**
 *
 */
export class HttpTransportRequestCancel extends RequestCancel {
    constructor() {
        super('Загрузка данных была отменена');
        this.name = 'HttpTransportRequestCancel';
    }
}
